import React from 'react';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

function CreateUserRoleSelect({ role, setRole }) {
  // Assume currentUserRole is stored in the auth state in Redux
  const currentUserRole = useSelector((state) => state.auth.user?.role);

  // Function to compute allowed roles based on currentUserRole
  const getAllowedRoles = () => {
    if (currentUserRole === 'superUser') {
      return [
        { value: '', label: 'Select Role' },
        { value: 'user', label: 'User' },
        { value: 'admin', label: 'Admin' },
        { value: 'superUser', label: 'Superuser' },
      ];
    } else if (currentUserRole === 'admin') {
      return [
        { value: '', label: 'Select Role' },
        { value: 'user', label: 'User' },
        { value: 'admin', label: 'Admin' },
      ];
    } else {
      return [
        { value: '', label: 'Select Role' },
        { value: 'user', label: 'User' },
      ];
    }
  };

  const allowedRoles = getAllowedRoles();

  return (
    <Form.Group controlId="formRole" className="mb-2">
      <Form.Label>Role</Form.Label>
      <Form.Control
        as="select"
        value={role}
        onChange={(e) => setRole(e.target.value)}
        required
      >
        {allowedRoles.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  );
}

export default CreateUserRoleSelect;
// In this example, we have a component CreateUserRoleSelect that renders a dropdown to select a user role. The available roles are computed based on the currentUserRole stored in the Redux state.